import CodeBlock from '../components/CodeBlock';

export default function Authentication() {
  return (
    <section id="authentication" className="mb-16">
      <h3 className="text-2xl font-bold text-gray-900 mb-4">Authentication</h3>
      <p className="text-gray-700 mb-4">
        Authenticate your API requests by including your secret API key in the request header.
        Your API keys are available in your dashboard under API Keys.
      </p>

      <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
        <p className="text-sm text-yellow-800">
          <strong>Keep your API key secure!</strong> Do not share your API key in publicly
          accessible areas such as GitHub, client-side code, etc.
        </p>
      </div>

      <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mb-6">
        <p className="text-sm text-blue-800">
          <strong>Email Verification Required:</strong> New accounts can make up to 10 API requests
          before email verification is required. Please verify your email address to continue using
          the API beyond this limit.
        </p>
      </div>

      <h4 className="text-lg font-semibold text-gray-900 mb-3">Example Request</h4>
      <CodeBlock section="auth" />
    </section>
  );
}